import React from 'react';

import RefuelContainer from './RefuelContainer';

import { RefuelProvider } from './hooks/useNewRefuel';

const NewRefuel: React.FC = () => {
  return (
    <RefuelProvider>
      <RefuelContainer />
    </RefuelProvider>
  );
};

export default NewRefuel;
